import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";

let opener = null;

export function askConfirm(message) {
  return new Promise((resolve) => {
    if (opener) opener({ type: "confirm", message, resolve });
    else resolve(window.confirm(message));
  });
}

export function askPrompt(message, defaultValue = "") {
  return new Promise((resolve) => {
    if (opener) opener({ type: "prompt", message, defaultValue, resolve });
    else resolve(window.prompt(message, defaultValue));
  });
}

// Scelta tra più opzioni: options = [{id, label, hint?}] → Promise<id|null>
export function askChoice(message, options) {
  return new Promise((resolve) => {
    if (opener) opener({ type: "choice", message, options, resolve });
    else resolve(null);
  });
}

export function ConfirmHost() {
  const { t } = useI18n();
  const [req, setReq] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => {
    opener = (r) => { setVal(r.defaultValue || ""); setReq(r); };
    return () => { opener = null; };
  }, []);
  if (!req) return null;
  const close = (result) => { req.resolve(result); setReq(null); };
  const cancel = () => close(req.type === "prompt" || req.type === "choice" ? null : false);
  const ok = () => close(req.type === "prompt" ? val : true);
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 p-4" onClick={cancel} data-testid="confirm-overlay">
      <div className="bg-card border border-border rounded-xl shadow-xl max-w-sm w-full p-5 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="confirm-dialog">
        <p className="text-sm whitespace-pre-line mb-4">{req.message}</p>
        {req.type === "prompt" && (
          <input autoFocus className="field w-full mb-4" value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") ok(); }} data-testid="confirm-prompt-input" />
        )}
        {req.type === "choice" ? (
          <div className="flex flex-col gap-2">
            {(req.options || []).map((o) => (
              <button key={o.id} className="btn-primary text-sm text-left px-4 py-2.5" onClick={() => close(o.id)} data-testid={`choice-${o.id}-btn`}>
                <span className="block font-semibold">{o.label}</span>
                {o.hint && <span className="block text-[11px] opacity-80 font-normal">{o.hint}</span>}
              </button>
            ))}
            <button className="btn-ghost text-sm" onClick={cancel} data-testid="confirm-cancel-btn">{t("cancel") || "Annulla"}</button>
          </div>
        ) : (
        <div className="flex justify-end gap-2">
          <button className="btn-ghost text-sm" onClick={cancel} data-testid="confirm-cancel-btn">{t("cancel") || "Annulla"}</button>
          <button className="btn-primary text-sm" onClick={ok} data-testid="confirm-ok-btn">{t("confirm") || "OK"}</button>
        </div>
        )}
      </div>
    </div>
  );
}
